var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticStyle:{"padding":"0px","height":"70px"}},[_c('navTopBar')],1),_c('el-main',{staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"page"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }